<script>
export default {
  data() {
    return {
      styles: {
        backgroundColor: this.providedBackgroundColor
      },
      src: this.providedImageSrc
    };
  },
  methods: {
  },
  watch: {
    headerColor(newColor) {
      this.styles.backgroundColor = newColor
    },
    headerImage(newSrc) {
      this.src = newSrc
    }
  },
  props: {
    providedBackgroundColor: String,
    providedImageSrc: String
  }
}
</script>

<template>
  <el-row>
    <el-col :span="24">
      <div class="agentHeaderWrapper" :style="styles">
        <img class="agentHeaderImage" alt="" :src="src"/>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.agentHeaderWrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.agentHeaderImage {
  position: relative;
  width: 84px;
  height: 35px;
  overflow: hidden;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/agentHeader.vue